/* eslint object-curly-newline: */
import { connect } from 'react-redux';
import LineChartComponent from './../Components/LineChartComponent.jsx';
import {
  artifactsMetricsPageReducer,
  getCaseMetricsArtifactFilteredTimings,
  getCaseMetricsArtifactMetrics,
  getMetricsPageHighlights,
} from './../reducers';
import { selectJob } from './../actions';
import Color from 'color';
import convert from 'color-convert';
import { values } from 'lodash';
import { metricsJobIdTooltipFooter } from './../helpers/chart';

const getColor = (size, index) => {
  const hue = (360 / size) * index;
  const rgb = convert.hsv.rgb(hue, 100, 100);
  return Color(`rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`).rgbaString();
};

const getSeries = (series, length) => {
  const pointRadius = length ? 0 : 4;
  const size = series.length;
  return series.map((s, index) => {
    return {
      label: s,
      pointRadius: pointRadius,
      pointBackgroundColor: getColor(size, index),
      backgroundColor: getColor(size, index),
      pointBorderColor: getColor(size, index),
      fill: true
    };
  });
};

const getData = (hunters, timings) =>
  hunters.map(h =>
    timings.map(t =>
      t && t[h] > 0 ? t[h] : null
    )
  );

const getSummedData = (groups, timings) =>
  groups.map(g =>
    timings.map(t =>
      t && t[g] ?
        values(t[g]).reduce((sum, num) => sum + num, 0) :
        null
    )
  );

export const mapStateToProps = (state, ownProps) => {
  const metrics = getCaseMetricsArtifactMetrics(state);
  const info = artifactsMetricsPageReducer.getArtifactsInfo(state);
  const hunters = artifactsMetricsPageReducer.getArtifactHunters(state);
  const groups = artifactsMetricsPageReducer.getArtifactsGroups(state);
  const filteredTimings = getCaseMetricsArtifactFilteredTimings(state)(ownProps);

  const data = info.inGroups ?
    getSummedData(groups, filteredTimings) :
    getData(hunters, filteredTimings);

  const highlights = getMetricsPageHighlights(state);
  const series = getSeries(
    info.inGroups ? groups : hunters,
    metrics.length
  );
  return {
    stacked: ownProps.stacked,
    data: data,
    series,
    labels: metrics.map(m => m ? m.jobNumber : m),
    lines: highlights,
    options: {
      legend: { display: false },
      scales: { xAxes: [{ offset: true }] },
      tooltips: {
        position: 'nearest',
        bodyFontSize: 10,
        caretPadding: -30,
        callbacks: {
          footer: (tooltipItem) => metricsJobIdTooltipFooter(tooltipItem)(metrics)
        }
      }
    }
  };
};

export default connect(
  mapStateToProps,
  { onClick: selectJob }
)(LineChartComponent);


// WEBPACK FOOTER //
// src/Containers/ArtifactMetricsTimingChartContainer.jsx